/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "mui-rff";
import NumberFormatCustom from "@/components/forms/NumberFormat";
import { Form } from "react-final-form";
import { LoadingButton } from "@mui/lab";
import { Card, CardActions, CardContent, Stack } from "@mui/material";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import SeriesFoliosTable from "@/features/user/seriesFolios/components/table";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const SeriesFolioForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        isModal,
        closePopover,
        series,
        setModalOpen,
        loading
    }: any): any => {

    const [t] = useTranslation();

    const otherComponent = <SeriesFoliosTable series={series} />

    const formFields: any[] = [
        {
            field:
                <Stack spacing={2}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" alignItems="baseline" spacing={2}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label={t("series.serie_label")}
                            name="serie"
                            required={required.serie}
                            inputProps={{
                                style: { textTransform: "uppercase" },
                            }}
                        />

                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label={t("series.folio_label")}
                            name="folio"
                            required={required.folio}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                            inputProps={{
                                decimalScale: 0,
                                prefix: '',
                                thousandSeparator: '',
                                fixedDecimalScale: false
                            }}
                        />
                    </Stack>
                    {/* <Typography variant="caption">
                        {t("series.table_label")}
                    </Typography> */}
                </Stack>
        },
    ];

    const modalProps: any = {
        hasMenuItem: true,
        label: t('series.title'),
        title: t('series.title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        closePopover,
        buttonSaveProps: {
            size: "medium",
            variant: "contained",
            text: t("series.add_btn_text")
        },
        otherComponent,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, errors, values }) => {
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Card
                                            elevation={0}
                                            sx={
                                                {
                                                    p: 1,
                                                    //bgcolor: GREY["300"],
                                                    boxShadow: 'none',
                                                    border: '1px dashed grey',
                                                    width: '100%'
                                                }
                                            }
                                        >
                                            <CardContent
                                                component={'div'}
                                                sx={{
                                                    p: 1,
                                                    mb: 0
                                                }}
                                            >
                                                <Stack direction="row" justifyContent="center"
                                                       alignItems="center" spacing={2}>
                                                    <Stack>
                                                        {formFields.map((item, idx) => (
                                                            <div key={idx}>
                                                                {item.field}
                                                            </div>
                                                        ))}
                                                    </Stack>
                                                    <Stack>
                                                        <LoadingButton
                                                            size="large"
                                                            type="submit"
                                                            variant="contained"
                                                            loading={submitting}

                                                        >
                                                            {t("series.add_btn_text")}
                                                        </LoadingButton>
                                                    </Stack>
                                                </Stack>
                                                <Stack direction="row">
                                                    {otherComponent}
                                                </Stack>
                                            </CardContent>

                                            <CardActions>
                                                {/* <LoadingButton
                                            size="small"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t("series.add_btn_text")}
                                        </LoadingButton> */}
                                            </CardActions>
                                        </Card>
                                    </form >
                                }
                            </>
                        );
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>
    );
}

export default SeriesFolioForm;